<template>
  <section class="page-section">
        <!-- filter -->
        <div class="filter-region no-margin-top">
          <div class="filter-form">
            <el-form size="small" :inline="true" :model="filterForm" ref="filterForm">
              <el-form-item label="订单号：" prop="orderNo">
                <el-input v-model="filterForm.orderNo" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="项目：" prop="commodityName">
                <el-autocomplete class="inline-input" v-model="filterForm.commodityName"
                  :fetch-suggestions="querySearch" :trigger-on-focus="false" placeholder="请输入"></el-autocomplete>
              </el-form-item>
              <el-form-item label="评价方式：" prop="systemDefault">
                <el-select v-model="filterForm.systemDefault" placeholder="请选择">
                  <el-option label="全部" value="-1"></el-option>
                  <el-option label="默认好评" value="1"></el-option>
                  <el-option label="用户自评" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="评价时间：" prop="commentTime" class="auto-width">
                <el-date-picker v-model="filterForm.commentTime" type="daterange" value-format="yyyy-MM-dd"
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="time-shortcut">
                <el-button plain @click="getLastFewDays(-7)"
                  :class="{ 'is-active': isActiveShortcut(-7) }">近7天</el-button>
                <el-button plain @click="getLastFewDays(-30)"
                  :class="{ 'is-active': isActiveShortcut(-30) }">近30天</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="filter-btn">
            <el-button-group class="btn-group">
              <el-button plain class="btn-reset" icon="el-icon-refresh"
                @click="filterFormReset('filterForm')"></el-button>
              <el-button type="primary" class="btn-search" @click="filterFormSubmit('filterForm')"
                :loading="tableLoading">查询</el-button>
            </el-button-group>
          </div>
        </div>

        <!-- table -->
        <div class="table-region" v-loading="tableLoading">
          <!-- 自定义表格 -->
          <div class="custom-table">
            <div class="custom-table-header">
              <el-row :gutter="10">
                <el-col :span="13">
                  <div class="table-cell">评价内容</div>
                </el-col>
                <el-col :span="4">
                  <div class="table-cell">评价时间</div>
                </el-col>
                <el-col :span="4">
                  <div class="table-cell">客户</div>
                </el-col>
                <el-col :span="3">
                  <div class="table-cell text-align-right">操作</div>
                </el-col>
              </el-row>
            </div>

            <div class="custom-table-body">

              <div class="no-data" v-if="tableData.length == 0">暂无数据</div>

              <div v-else>
                <div v-for="(item, index) in tableData" :key="index">
                  <!-- order item -->
                  <div class="order-list-item">
                    <div class="item-header">
                      <el-row :gutter="10">
                        <el-col>
                          <div class="table-cell">
                            <div class="img-wrap">
                              <span class="text">订单号：<el-button type="text" size="small"
                                  @click="pageLinkToOrderDetail(item)">{{ item.orderNo }}</el-button></span>
                              <div class="img-box">
                                <img :src="item.commodityPic">
                              </div>
                              <span class="text" style="margin-left: 10px;">{{ item.commodityName }}</span>
                              <span class="text">门店：{{ item.shopName }}</span>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                    <div class="item-body">
                      <div class="comment">{{ item.content }}</div>
                      <el-row :gutter="10">
                        <el-col :span="13">
                          <div class="table-cell no-padding">
                            <el-row :gutter="10">
                              <el-col :span="17">
                                <div class="table-cell">
                                  <div class="img-wrap">
                                    <div style="cursor: pointer;" class="img-box comment-img"
                                      v-for="(scope, index) in item.commentPics" :key="index" @click="showPic(scope)">
                                      <img :src="scope">
                                    </div>
                                  </div>
                                </div>
                              </el-col>
                            </el-row>
                          </div>
                        </el-col>
                        <el-col :span="4">
                          <div class="table-cell">
                            <p class="text">{{ item.commentTimeStr }}</p>
                          </div>
                        </el-col>
                        <el-col :span="4">
                          <div class="table-cell">
                            <p class="text">{{ item.userName }}</p>
                          </div>
                        </el-col>
                        <el-col :span="3">
                          <div class="table-cell text-align-right">
                            <p class="text">
                              <el-button type="text" size="small" @click="reply(item)" v-if="!item.feedback"
                                style="margin-right: 10px">回复</el-button>

                              <el-popover placement="top" width="165" v-model="item.upVisible"
                                popper-class="confirm-popover">
                                <p>是否删除该评价？</p>
                                <div>
                                  <el-button size="small" type="default" plain
                                    @click="item.upVisible = false">取消</el-button>
                                  <el-button size="small" type="primary" @click="del(item)">确定</el-button>
                                </div>

                                <el-button size="small" type="text" slot="reference">删除</el-button>

                              </el-popover>
                            </p>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>

                  <div class="custom-table-footer" v-if="item.feedback">
                    <div class="custom-table-footer-box flex-h">
                      <div class="reply">商家回复：</div>
                      <div class="reply-content flex-a-i">
                        <p>{{ item.feedback }}</p>
                        <p>{{ item.feedbackTimeStr }}</p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="table-footer" v-if="page.total > 0">
          <div class="selection-operate"></div>

          <div class="pagination-wrap">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :page-sizes="[20, 50, 100]" :pager-count="5" :current-page="page.current" :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper" :total="page.total">
            </el-pagination>
          </div>
        </div>


<el-dialog :title="'回复' + formDialog.replyName" :visible.sync="dialogShow" width="30%" class="reply-dialog">
  <el-form size="small" ref="formDialog" :model="formDialog" label-width="0px" class="dialog-form" :rules="rules">
    <el-form-item class="reply-textarea" prop="feedback">
      <el-input resize="none" maxlength="200" type="textarea" :rows="8" v-model="formDialog.feedback"
        placeholder="用礼貌的回复给买家留下一个美好的购物印象吧（不可少于5个字）" @input="watchReplyCount"></el-input>
      <div class="reply-count">{{ formDialog.replyCount }}/200</div>
    </el-form-item>
  </el-form>

  <span slot="footer" class="dialog-footer">
    <el-button size="small" plain @click="dialogShow = false">取 消</el-button>
    <el-button size="small" type="primary" @click="handleReply('formDialog')" :loading="formDialog.replyLoading">确
      定</el-button>
  </span>
</el-dialog>

<el-dialog title="查看大图" :visible.sync="picShow">
  <img :src="url">
</el-dialog>
      </section>
</template>

<script>

import { commentList, commentReply, commentDelete, commodityNameList, COMMON } from '../../../common/api'

export default {
  name: 'goodsManageList',
  data() {
    return {
      tabName: '1', //选项卡name

      filterForm: { //筛选表单值
        orderNo: '', // 订单号
        commodityName: '', // 商品名
        star: '', // 评价星级
        systemDefault: "-1", // 评价方式
        commentTime: '' // 评价时间起止点
      },

      page: { // 分页参数
        current: 1,
        size: 20,
        total: 0
      },

      tableLoading: true,
      tableData: [], // 表格数据
      goodsList: [], // 商品名列表

      dialogShow: false, // 回复弹窗
      picShow: false, // 查看大图弹窗
      url: '', // 查看的大图地址
      formDialog: { // 弹窗参数
        replyName: '', // 回复的买家名
        replyId: '', // 回复的id
        feedback: '', // 回复内容
        replyCount: 0, // 回复的字符长度
        replyLoading: false
      },
      rules: {
        feedback: [
          { required: true, message: '请输入回复内容', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    /**
     * [getCommodityNameList description] 获取商品名列表
     * @return {[type]} [description]
     */
    getCommodityNameList: function () {
      this.goodsList = [];
      commodityNameList().then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          for (let i in data) {
            this.goodsList.push({ value: data[i] });
          }
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      })
    },
    /**
     * [getList description] 获取表格数据
     * @return {[type]} [description]
     */
    getList: function () {
      this.tableLoading = true;

      let param = {
        type: 1,
        "orderNo": this.filterForm.orderNo,
        "commodityName": this.filterForm.commodityName,
        'star': this.filterForm.star,
        'systemDefault': this.filterForm.systemDefault == '-1' ? null : this.filterForm.systemDefault,
        "startTime": this.filterForm.commentTime ? this.filterForm.commentTime[0] : '',
        "endTime": this.filterForm.commentTime ? this.filterForm.commentTime[1] : '',
        "current": this.page.current,
        "size": this.page.size
      }
      if (this.star > 0) {
        param.star = Number(this.filterForm.star);
      }

      commentList(param).then(res => {
        this.tableLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          this.tableData = data.records || [];
          this.page.total = data.total;

          this.$nextTick(() => {
            const scrollContainer = document.querySelector('.app-container');
            if (scrollContainer) {
              scrollContainer.scrollTop = 0;
            }
          });
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.tableLoading = false;
        this.$message.error('服务器异常');
      })
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择表格第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    /**
     * [filterFormSubmit description] 提交筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormSubmit: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getList();
        } else {
          return false;
        }
      });
    },
    /**
     * [filterFormReset description] 重置筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * [reply description] 打开回复弹窗
     * @param  {[Object]} item [description] 要回复的对象
     * @return {[type]}          [description]
     */
    reply: function (item) {
      this.formDialog.feedback = '';

      this.formDialog.replyName = item.userName;
      this.formDialog.replyId = item.id;
      this.dialogShow = true;
    },
    /**
     * [watchReplyCount description] 监听输入字数
     * @param  {[String]} val [description] 输入框内的值
     * @return {[type]}          [description]
     */
    watchReplyCount: function (val) {
      this.formDialog.replyCount = val.split('').length;
    },
    /**
     * [handleReply description] 确定回复
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    handleReply: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formDialog.replyLoading = true;

          let param = {
            "id": this.formDialog.replyId,
            "feedback": this.formDialog.feedback
          }

          commentReply(param).then(res => {
            this.formDialog.replyLoading = false;

            let { code, data, msg } = res;

            if (code == 0) {
              this.dialogShow = false;
              this.$message.success('回复成功');
              this.getList();
            } else {
              this.$message.error(msg);
            }
          }).catch(error => {
            this.formDialog.replyLoading = false;
            this.$message.error('服务器异常');
          })
        } else {
          return false;
        }
      });
    },
    /**
     * [del description] 删除评价
     * @param  {[Object]} item [description] 删除列对象
     * @return {[type]}        [description]
     */
    del: function (item) {
      let param = {
        "id": item.id
      }

      commentDelete(param).then(res => {
        item.upVisible = false;

        let { code, data, msg } = res;

        if (code == 0) {
          this.$message.success('删除成功');
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        item.upVisible = false;
        this.$message.error('服务器异常');
      })
    },
    /**
     * [showPic description] 查看大图
     * @param  {[String]} url [description] 图片地址
     * @return {[type]}        [description]
     */
    showPic: function (url) {
      this.url = url;
      this.picShow = true;
    },
    /**
     * [pageLinkToGoddsDetail description] 查看商品详情
     * @param  {[Object]} item [description] 操作对象
     * @return {[type]}        [description]
     */
    pageLinkToGoddsDetail: function (item) {
      this.$router.push({ path: '/goods/manage/add', query: { id: item.commodityId } });
    },
    /**
     * [pageLinkToOrderDetail description] 查看订单详情
     * @param  {[Object]} item [description] 操作对象
     * @return {[type]}        [description]
     */
    pageLinkToOrderDetail: function (item) {
      this.$router.push({ path: '/order/order/detail', query: { id: item.orderId } });
    },
    /**
     * [getLastFewDays description] 获取近几日日期
     * @param  {[Number]} day [description] 需要获取的近几日的数值
     * @return {[type]}        [description]
     */
    getLastFewDays: function (day) {
      this.filterForm.commentTime = [];
      this.filterForm.commentTime.push(COMMON.getDay(day));
      this.filterForm.commentTime.push(COMMON.getDay(0));
    },
    /**
     * 判断时间快捷选项是否处于选中状态
     */
    isActiveShortcut(day) {
      if (!this.filterForm.commentTime || this.filterForm.commentTime.length !== 2) return false;
      return this.filterForm.commentTime[0] === COMMON.getDay(day) &&
        this.filterForm.commentTime[1] === COMMON.getDay(0);
    },
    // 商品搜索联想
    querySearch(queryString, cb) {
      var goodsList = this.goodsList;
      var results = queryString ? goodsList.filter(this.createFilter(queryString)) : goodsList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (goodsList) => {
        return (goodsList.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    }
  },
  mounted() {
    this.getCommodityNameList();
    this.getList();
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";

.comment {
  padding: 12px 10px 0 10px;
  font-size: $smallFS;
  color: $textColor;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.reply-dialog {

  ::v-deep .el-dialog {
    min-width: 400px !important;
  }

  .reply-textarea {
    position: relative;

    .reply-count {
      position: absolute;
      right: 15px;
      bottom: 5px;
      line-height: 18px;
      color: $tipsDisabledColor;
    }
  }
}

// .page-container {
//   height: 100%;
// }

// .page-main {
//   flex: 1;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column;
// }

// .page-section {
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   overflow: hidden;
// }

.filter-region {
  // flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;
  justify-content: space-between;

  .el-form-item {
    &.time-shortcut {
      background: initial;
      padding: 0;

      :deep(.el-form-item__content) {
        width: auto;

        .el-button {
          width: 110px;
          height: 40px;
          border-radius: 5px;

          &.is-active {
            border: 1px solid #3388FF;
            color: #3388FF;
            background-color: #ecf5ff;
          }
        }
      }
    }
  }


  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        &+.el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }
}

.table-region {
  // flex: 1; // 占用剩余高度
  // display: flex;
  // flex-direction: column;
  // overflow: hidden;
  margin-bottom: 50px;

  .custom-table {
    // flex: 1;
    // display: flex;
    // flex-direction: column;
    // overflow: hidden;

    .custom-table-header {
      // flex-shrink: 0;
      padding-right: 4px;
      text-align: center;
      scrollbar-gutter: stable;
    }

    .custom-table-body {
      // flex: 1;
      // overflow-y: auto;
      // overflow-x: hidden;
      padding-right: 5px; // 避免滚动条遮挡内容
    }
  }

  // .table-footer {
  //   flex-shrink: 0;
  // }

  .custom-table-footer {

    .reply,
    .reply-content {
      padding: 5px 0;
      font-size: $smallFS;
    }

    .reply {
      width: 60px;
      color: $compeleteColor;
    }

    .reply-content {

      p {
        &:first-child {
          margin-bottom: 10px;
          color: $textColor;
        }

        &:last-child {
          color: $tipsColor;
        }
      }
    }
  }
}
</style>
